import { logger } from '@/utils/logger/logger';
import { getCurrentSessionId } from '@heidi/runtime/shell';

/**
 * Marks a copy/export whose payload came back through a serializer fallback,
 * so a degraded operation is distinguishable in Datadog from the clean success
 * its analytics event still reports. Join on `session_id` with the paired
 * `[MD] serializer fell back to input` error for the failing serializer.
 */

export type SerializerFallbackSurface = 'copy' | 'export' | 'print';

// Resolved in its own try so a router failure costs only the id, not the warn.
const resolveSessionId = (sessionId?: string): string => {
  try {
    return sessionId || getCurrentSessionId() || '';
  } catch {
    return '';
  }
};

export const reportSerializerFallback = ({
  surface,
  sessionId,
}: {
  surface: SerializerFallbackSurface;
  sessionId?: string;
}): void => {
  try {
    logger.warn('[MD] output served serializer fallback', {
      surface,
      session_id: resolveSessionId(sessionId),
    });
  } catch {
    // A tripwire must never change whether a copy or export succeeds.
  }
};
